// extracted by mini-css-extract-plugin
export var icon = "_sf-0";